import type { AnalyticsDialogsRequest } from './generated-api';
import { generatedApi } from './generated-api';

export type WidgetChangesRequest = Pick<
  AnalyticsDialogsRequest,
  'organization_id' | 'channel_ids' | 'date_from' | 'date_to' | 'interval'
>;

export type WidgetChange = {
  id: number;
  change_group: string;
  agent_id: number | null;
  widget_settings_id: number | null;
  actor_id: number;
  entity_type: string;
  entity_id: number | null;
  property_name: string;
  action: 'added' | 'changed' | 'removed';
  position: number | null;
  old_value: unknown;
  new_value: unknown;
  created_at: string;
  subject_name?: string | null;
  entity_name?: string | null;
  actor_name?: string | null;
  old_value_name?: string | null;
  new_value_name?: string | null;
};

export type WidgetChangeBucket = {
  date: string;
  change_count: number;
  latest: WidgetChange[];
};

export type WidgetChangesTimeline = {
  interval: 'day' | 'hour';
  buckets: WidgetChangeBucket[];
};

export type WidgetChangesDetails = {
  date: string;
  total_count: number;
  group_count: number;
  changes: WidgetChange[];
};

export type WidgetChangesDetailsRequest = WidgetChangesRequest & {
  bucket_start: string;
  limit: number;
  offset: number;
};

export const widgetChangesApi = generatedApi.injectEndpoints({
  endpoints: (build) => ({
    getWidgetChanges: build.query<WidgetChangesTimeline, WidgetChangesRequest>({
      query: (body) => ({ url: '/analytics/widget/changes', method: 'POST', body }),
    }),
    getWidgetChangeDetails: build.query<WidgetChangesDetails, WidgetChangesDetailsRequest>({
      query: (body) => ({ url: '/analytics/widget/changes/details', method: 'POST', body }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetWidgetChangesQuery, useGetWidgetChangeDetailsQuery } = widgetChangesApi;
